module.exports = __webpack_public_path__ + "img/icon-gauge.bea074c1.png";